var _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9, _path12, _g10, _path13, _g11, _path14, _g12, _path15, _g13, _path16, _g14, _path17, _g15, _path18, _g16, _path19, _g17, _path20, _g18, _path21, _g19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaitingCallIcon = function SvgWaitingCallIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 79.999C160 124.183 124.184 159.999 80 159.999C35.8163 159.999 0 124.183 0 79.999C0 35.8163 35.8163 0 80 0C124.184 0 160 35.8163 160 79.999Z",
    fill: "#50A5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.085 58.5465H101.905V50.0153C101.905 47.4062 99.7907 45.2918 97.1816 45.2918H56.4879C53.8864 45.2918 51.7645 47.4062 51.7645 50.0153V57.1873H49.5845V50.0153C49.5845 46.2076 52.6877 43.1118 56.4879 43.1118H97.1816C100.99 43.1118 104.085 46.2076 104.085 50.0153V58.5465Z",
    fill: "#3776AB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5842 57.1874H51.7642V54.3459H49.5842V57.1874Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.905 58.5462H104.085V54.3459H101.905V58.5462Z",
    fill: "#333333"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.356 125.095H31.3813V65.0281C31.3813 59.8108 35.611 55.5812 40.8283 55.5812H118.909C124.127 55.5812 128.356 59.8108 128.356 65.0281V125.095Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.356 65.0281V125.095H112.027V55.5812H118.909C124.127 55.5812 128.356 59.8108 128.356 65.0281Z",
    fill: "#3776AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2693 89.0331H128.602V88.6699H30.2693V89.0331Z",
    fill: "#412424"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6789 95.4071C42.9442 95.4071 41.5251 93.9877 41.5251 92.2534V87.1818C41.5251 85.4471 42.9446 84.0281 44.6789 84.0281C46.4136 84.0281 47.8327 85.4475 47.8327 87.1818V92.2534C47.8327 93.9881 46.4136 95.4071 44.6789 95.4071Z",
    fill: "#3776AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6178 95.4071C95.883 95.4071 94.4636 93.9877 94.4636 92.2534V87.1818C94.4636 85.4471 95.883 84.0281 97.6178 84.0281C99.3525 84.0281 100.772 85.4475 100.772 87.1818V92.2534C100.772 93.9881 99.3525 95.4071 97.6178 95.4071Z",
    fill: "#3776AB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.3704 103.643C62.835 97.3913 69.0905 93.5105 75.3423 94.9751C81.594 96.4401 85.4748 102.695 84.0102 108.947C82.5452 115.199 76.2901 119.08 70.0383 117.615C63.7866 116.15 59.9058 109.895 61.3704 103.643Z",
    fill: "#AB5998"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.5615 100.586L73.9212 100.557L74.0673 112.243L71.7077 112.273L71.5615 100.586Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.6474 105.159L78.6768 107.518L66.9903 107.665L66.9609 105.305L78.6474 105.159Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 12.4687V40.2777H132.204L127.893 48.4695L141.043 40.709H160.013V11.6064C160.013 11.6064 110 12.6842 110 12.4687Z",
    fill: "#D16AB9"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.683 18.633L139.425 18.5988L139.595 32.1774L136.853 32.2117L136.683 18.633Z",
    fill: "#FFE9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.913 23.9427L144.948 26.6844L131.369 26.8543L131.335 24.1126L144.913 23.9427Z",
    fill: "#FFE9FB"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.0147 18.6033C85.9519 18.6033 84.2733 20.2815 84.2733 22.3443C84.2733 24.4071 85.9519 26.0854 88.0147 26.0854C90.0776 26.0854 91.7554 24.4071 91.7554 22.3443C91.7554 20.2815 90.0776 18.6033 88.0147 18.6033ZM88.0147 26.4847C85.7319 26.4847 83.874 24.6271 83.874 22.3443C83.874 20.0615 85.7319 18.204 88.0147 18.204C90.2976 18.204 92.1547 20.0615 92.1547 22.3443C92.1547 24.6271 90.2976 26.4847 88.0147 26.4847Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5684 135.054C83.5056 135.054 81.8278 136.733 81.8278 138.796C81.8278 140.858 83.5056 142.537 85.5684 142.537C87.6313 142.537 89.3098 140.858 89.3098 138.796C89.3098 136.733 87.6313 135.054 85.5684 135.054ZM85.5684 142.936C83.2856 142.936 81.4285 141.078 81.4285 138.796C81.4285 136.512 83.2856 134.655 85.5684 134.655C87.8512 134.655 89.7091 136.512 89.7091 138.796C89.7088 141.078 87.8509 142.936 85.5684 142.936Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.413 75.7073C11.9861 75.7073 10.8296 74.5508 10.8296 73.1238C10.8296 71.6969 11.9861 70.5404 13.413 70.5404C14.84 70.5408 15.9964 71.6973 15.9964 73.1238C15.9964 74.5508 14.84 75.7073 13.413 75.7073Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.8843 17.7836L68.1984 18.8176L63.9604 19.991L62.9268 24.3054L61.7533 20.0675L57.439 19.0335L61.6769 17.86L62.7109 13.5457L63.8843 17.7836Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.894 66.9956L149.208 68.0293L144.97 69.2027L143.936 73.5171L142.763 69.2792L138.448 68.2451L142.686 67.0717L143.72 62.7577L144.894 66.9956Z",
    fill: "#E2F2FF"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_1120_3788",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 4,
    width: 160,
    height: 153
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M2 156.186H162V4H2V156.186Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_1120_3788)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7486 142.14L74.0626 143.174L69.8251 144.348L68.791 148.662L67.6176 144.424L63.3032 143.39L67.5411 142.217L68.5752 137.902L69.7486 142.14Z",
    fill: "#E2F2FF"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaitingCallIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waiting-call-icon.40aa73c7.svg";
export { ForwardRef as ReactComponent };